import React, { useState, useEffect } from 'react';
import { Table, Row, Col, Button, notification, Tooltip, Tag } from "antd";
import { RiLockPasswordLine } from "react-icons/ri";
import { HiOutlineUsers } from "react-icons/hi";
import { FaPlusCircle } from "react-icons/fa";
import auth from '../services/authService';
import UserForm from './UserForm';
import ChangePasswordForm from './ChangePasswordForm';
import RolesModal from './RolesModal';

function Users() {
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [showRolesModal, setShowRolesModal] = useState(false);
    const [roles, setRoles] = useState([]);
    const [saveRolesLoading, setSaveRolesLoading] = useState(false);

    const cols = [
        { dataIndex: "userName", title: "Nombre" },
        { 
            dataIndex: "roles",
            title: "Roles",
            render: (values) => values && values.map(r => <Tag key={r.id}>{r.name}</Tag>)
        },
        { 
            dataIndex: "id",
            title: "",
            render: (_, row) => <div>
                <Tooltip title="Cambiar contraseña">
                    <RiLockPasswordLine onClick={() => {
                        setSelectedUser(row);
                        setShowPasswordModal(true);
                    }}/>
                </Tooltip>&nbsp;|&nbsp; 
                <Tooltip title="Roles">
                    <HiOutlineUsers onClick={() => {
                        setSelectedUser(row);
                        setShowRolesModal(true);
                    }} />
                </Tooltip>
            </div>}
    ];

    useEffect(() => {
        async function process(){
            setLoading(true);
            const response = await auth.getUsers();
            setUsers(response.data);
            setLoading(false);

            // Roles
            const { data } = await auth.getRoles();
            setRoles(data.map(d => ({ key: d.id, title: d.name, description: d.name })));
        }

        process();
    }, []);

    const createHandle = (user) => {
        setShowModal(false);
        const temp = users;
        temp.push(user);
        setUsers([...temp]);
        notification["success"]({ message: "Usuario", description: "Se creó el usuario."});
    };

    const passwordChangeHandler = () => {
        setShowPasswordModal(false);
        notification["success"]({ message: "Usuario", description: "Se cambió la contraseña."});
    };

    const rolesChangeHandler = async (nextTargetKeys) => {
        if(nextTargetKeys.length <= 0){
            notification["warning"]({ message: "Usuario", description: "Debe tener al menos un rol."});
            return;
        }

        setSaveRolesLoading(true);
        await auth.setRoles(selectedUser.id, nextTargetKeys);
        const su = selectedUser;
        su.roles = roles.filter(r => nextTargetKeys.includes(r.key)).map(r => ({ id: r.key, name: r.title }));;
        setSelectedUser({...su});
        setSaveRolesLoading(false);
    };

    return (<div className="mainContainer">
        <Row>
            <Col span={24}>
                <h1 className="title">Usuarios</h1>
                <hr className="hr-title"/>
            </Col>
        </Row>
        <Row className="detailContainer">
            <Col span={24}>
                <div className="divRight">
                    <Button type="primary" icon={<FaPlusCircle/>} onClick={() => setShowModal(true)}>
                    &nbsp; Nuevo
                    </Button>
                </div>
            </Col>
            <Col span={24}>
                <UserForm visible={showModal}
                    onCancel={() => setShowModal(false)}
                    onCreate={createHandle} 
                    onValidUsername={(username) => !users.some(u => u.userName.toLowerCase() === username.toLowerCase())} />
                <ChangePasswordForm visible={showPasswordModal} userId={selectedUser && selectedUser.id}
                    onCancel={() => setShowPasswordModal(false)}
                    onChanged={passwordChangeHandler} />
                <RolesModal visible={showRolesModal} roles={roles} targets={selectedUser && selectedUser.roles && selectedUser.roles.map(r => r.id)}
                    user={selectedUser} loading={saveRolesLoading}
                    onCancel={() => setShowRolesModal(false)}
                    onChange={rolesChangeHandler} />
                <br/>
                <Table rowKey="id" dataSource={users} columns={cols} loading={loading}/>
            </Col>
        </Row>
    </div>);
}

export default Users;


// WEBPACK FOOTER //
// ./src/components/Users.jsx